// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function FundInvestorPairFromJSON(json) {
    return {
        'fundId': !exists(json, 'fundId') ? undefined : json['fundId'],
        'investorId': !exists(json, 'investorId') ? undefined : json['investorId'],
    };
}
export function FundInvestorPairToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'fundId': value.fundId,
        'investorId': value.investorId,
    };
}
